import { Button } from "@mui/material"; // Importa el componente Button de Material UI
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'; // Importa el ícono de flecha hacia atrás de Material UI
import { useNavigate } from "react-router-dom"; // Importa el hook 'useNavigate' de react-router-dom para manejar la navegación entre páginas

export default function Tiling() { // Define el componente funcional 'Tiling'
  const navigate = useNavigate(); // Inicializa el hook 'useNavigate' para navegar entre rutas
  
  // Estilos para el iframe que contiene el reproductor de SoundCloud
  const iframeStyles = {
    width: '100%', // Establece el ancho del iframe al 100% del contenedor
    height: '100%', // Establece la altura del iframe al 100% del contenedor
    scrolling: 'no', // Desactiva el desplazamiento dentro del iframe
    frameborder: 'no', // Elimina el borde del iframe
    allow: 'autoplay', // Permite la reproducción automática del contenido dentro del iframe
  };

  // Estilos para los contenedores que envuelven cada iframe
  const containerStyles = {
    backgroundColor: 'rgb(97, 185, 207)', // Define el color de fondo de los contenedores
    width: "40%", // Define el ancho de los contenedores
    marginLeft: "20%", // Define el margen izquierdo para centrar los contenedores
    zIndex: 100, // Define el índice Z para la superposición de los elementos
  };

  // Estilos para el texto dentro de cada contenedor
  const textStyles = {
    fontSize: '10px', // Define el tamaño de la fuente del texto
    color: '#cccccc', // Define el color del texto
    lineBreak: 'anywhere', // Permite el salto de línea en cualquier lugar
    wordBreak: 'normal', // Establece el corte de palabras
    overflow: 'hidden', // Oculta el contenido que se desborda
    whiteSpace: 'nowrap', // Evita que el texto se divida en varias líneas
    textOverflow: 'ellipsis', // Muestra puntos suspensivos si el texto es muy largo
    fontFamily: 'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif', // Define la fuente del texto
    fontWeight: 100, // Define el peso de la fuente
  };

  return (
    <>
      <Button onClick={() => navigate("/sonidos")}> {/* Botón para navegar a la página principal */}
        <ArrowBackIosNewOutlinedIcon /> {/* Icono de flecha hacia atrás en el botón */}
      </Button>
      <div style={{ marginTop: "5%" }}> {/* Contenedor para los elementos con un margen superior del 5% */}
        
        {/* Primer reproductor de SoundCloud */}
        <div
          id="tiling-sonification.head.166077097711" // Asigna un ID único al contenedor
          className="text resizable object" // Aplica clases de estilo
          style={{ ...containerStyles }} // Aplica los estilos al contenedor
        >
          <iframe
            style={iframeStyles} // Aplica los estilos al iframe
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1334277688&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true&amp;visual=true" // URL del primer track de SoundCloud
            allow="autoplay" // Permite la reproducción automática
            title="Tiling Sonification Hypercube" // Título del iframe
          />
          <div style={textStyles}> {/* Estilo para el texto debajo del reproductor */}
            <a
              href="https://soundcloud.com/labvs-imate-unam" // Enlace al perfil de SoundCloud
              title="labvs.imate.unam" // Título del enlace
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer" // Mejora la seguridad al abrir el enlace
              style={{ color: '#cccccc', textDecoration: 'none' }} // Estilos del enlace (color y sin subrayado)
            >
              labvs.imate.unam {/* Nombre de usuario de SoundCloud */}
            </a> · 
            <a
              href="https://soundcloud.com/labvs-imate-unam/tiling-sonification-hypercube" // Enlace al track específico
              title="Tiling sonification hypercube" // Título del enlace
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer" // Mejora la seguridad al abrir el enlace
              style={{ color: '#cccccc', textDecoration: 'none' }} // Estilos del enlace
            >
              Tiling sonification hypercube {/* Nombre del track */}
            </a>
          </div>
        </div>

        {/* Segundo reproductor de SoundCloud */}
        <div
          id="tiling-sonification.head.166654090125" // Asigna un ID único al contenedor
          className="text resizable object" // Aplica clases de estilo
          style={{ ...containerStyles }} // Aplica los estilos al contenedor
        >
          <iframe
            style={iframeStyles} // Aplica los estilos al iframe
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1334095621&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true&amp;visual=true" // URL del segundo track de SoundCloud
            allow="autoplay" // Permite la reproducción automática
            title="Tiling Variation 1" // Título del iframe
          />
          <div style={textStyles}> {/* Estilo para el texto debajo del reproductor */}
            <a
              href="https://soundcloud.com/labvs-imate-unam" // Enlace al perfil de SoundCloud
              title="labvs.imate.unam" // Título del enlace
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer" // Mejora la seguridad al abrir el enlace
              style={{ color: '#cccccc', textDecoration: 'none' }} // Estilos del enlace
            >
              labvs.imate.unam {/* Nombre de usuario de SoundCloud */}
            </a> · 
            <a
              href="https://soundcloud.com/labvs-imate-unam/tiing-variation-1" // Enlace al track específico
              title="Tiling Variation 1" // Título del enlace
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer" // Mejora la seguridad al abrir el enlace
              style={{ color: '#cccccc', textDecoration: 'none' }} // Estilos del enlace
            >
              Tiling Variation 1 {/* Nombre del track */}
            </a>
          </div>
        </div>

        {/* Tercer reproductor de SoundCloud */}
        <div
          id="tiling-sonification.head.16665412764" // Asigna un ID único al contenedor
          className="text resizable object" // Aplica clases de estilo
          style={{ ...containerStyles }} // Aplica los estilos al contenedor
        >
          <iframe
            style={iframeStyles} // Aplica los estilos al iframe
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1368621925&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true&amp;visual=true" // URL del tercer track de SoundCloud
            allow="autoplay" // Permite la reproducción automática
            title="Tiling Variation 2" // Título del iframe
          />
          <div style={textStyles}> {/* Estilo para el texto debajo del reproductor */}
            <a
              href="https://soundcloud.com/labvs-imate-unam" // Enlace al perfil de SoundCloud
              title="labvs.imate.unam" // Título del enlace
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer" // Mejora la seguridad al abrir el enlace
              style={{ color: '#cccccc', textDecoration: 'none' }} // Estilos del enlace
            >
              labvs.imate.unam {/* Nombre de usuario de SoundCloud */}
            </a> · 
            <a
              href="https://soundcloud.com/labvs-imate-unam/tiling-variation-2" // Enlace al track específico
              title="Tiling Variation 2" // Título del enlace
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer" // Mejora la seguridad al abrir el enlace
              style={{ color: '#cccccc', textDecoration: 'none' }} // Estilos del enlace
            >
              Tiling Variation 2 {/* Nombre del track */}
            </a>
          </div>
        </div>
      </div>    
    </>
  );
}
